export default __webpack_public_path__ + "static/media/regency.55ca7e7d.jpg";